import { Component, OnInit, OnDestroy, ViewChild, HostListener, AfterViewInit, ApplicationRef, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MatListModule, MatSidenavModule } from '@angular/material';
import { ShareService } from '../../shared/services/share.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    providers: [ShareService]
})
export class LayoutComponent implements OnInit, OnDestroy, AfterViewInit {
    @ViewChild('sidemenu') sidemenu;
    @ViewChild('header') header;
    public subscription: Subscription;
    
    constructor(public shareService: ShareService) {
        // get current user info to update user name in header (fix bug SD10001680-268)
        this.subscription = this.shareService.getUserInfoUpdate().subscribe(
            data => {
            this.header.updateUserInfo(data);
        });
    }

    ngOnInit(): void {
        this.sidemenu.toggle();
    }

    ngAfterViewInit() {
    }

    ngOnDestroy() {
        // unsubscribe to ensure no memory leaks
        this.subscription.unsubscribe();
    }


}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/components/layout/layout.component.ts